import React from 'react';
import {Group} from '@lib/store';
import {GroupAvatar} from '@molecules';
import {useTranslation} from 'react-i18next';
import {H1, Subtitle} from '@quarks';

export const GroupInviteHeader = ({group}: {group: Group}) => {
  const {t} = useTranslation();
  const acceptedMembers = group.members.filter((member) => member.status === 'Accepted');
  return (
    <div className="py-8 px-5 bg-beige-200 flex flex-col justify-center items-center gap-4 -mx-[var(--modal-padding-x)] -mt-[var(--modal-padding-y)]">
      <GroupAvatar
        className="shadow-mapiq-base"
        group={group}
        size="xlarge"
      />
      <div className="flex flex-col gap-1 justify-center items-center">
        <H1 className="">{group.name}</H1>
        <Subtitle className="">{t('groups:Member', {count: acceptedMembers.length})}</Subtitle>
      </div>
    </div>
  );
};
